/* (function () {
  'use strict';

  const GALLERY_IMG_SELECTORS = [
    '.product__media-wrapper .product__media img',
    '.product-single__photo img',
    '[data-product-featured-media] img',
    '.product__media img',
    '.product-gallery__main img',
  ];

  const MANNEQUIN_ACTIVE_CLASS = 'product-option__label--mannequin-active';

  function findGalleryImage() {
    for (const selector of GALLERY_IMG_SELECTORS) {
      const el = document.querySelector(selector);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  function swapGalleryImage(newSrc) {
    if (!newSrc) return;
    const img = findGalleryImage();
    if (!img) return;

    img.style.transition = 'opacity 0.18s ease';
    img.style.opacity = '0';

    img.addEventListener('transitionend', function handler() {
      img.removeEventListener('transitionend', handler);
      img.srcset = '';
      img.src = newSrc;
      img.style.opacity = '1';
    });
  }

  function handleSwatchChange(input) {
    const galleryImgUrl = input.dataset.galleryImg;
    if (galleryImgUrl) {
      swapGalleryImage(galleryImgUrl);
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.remove(MANNEQUIN_ACTIVE_CLASS);
    }
  }

  function handleMannequinToggle(e) {
    e.preventDefault();
    e.stopPropagation();

    const trigger = e.currentTarget;
    const label = trigger.closest('label');
    if (!label) return;

    const input = document.getElementById(label.getAttribute('for'));
    if (!input) return;

    const mannequinUrl = input.dataset.mannequinImg;
    const galleryUrl   = input.dataset.galleryImg;
    if (!mannequinUrl) return;

    const isActive = label.classList.contains(MANNEQUIN_ACTIVE_CLASS);

    if (isActive) {
      label.classList.remove(MANNEQUIN_ACTIVE_CLASS);
      if (galleryUrl) swapGalleryImage(galleryUrl);
    } else {
      label.classList.add(MANNEQUIN_ACTIVE_CLASS);
      swapGalleryImage(mannequinUrl);
    }
  }

  function init(variantSelectsEl) {
    variantSelectsEl.addEventListener('change', (e) => {
      const input = e.target;
      if (input.tagName === 'INPUT' && input.type === 'radio' && input.classList.contains('product-option__input')) {
        handleSwatchChange(input);
      }
    });

    variantSelectsEl.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-mannequin-trigger]');
      if (trigger) handleMannequinToggle(e);
    });

    const checkedInput = variantSelectsEl.querySelector('.product-option__input:checked[data-gallery-img]');
    if (checkedInput) handleSwatchChange(checkedInput);
  }

  function boot() {
    document.querySelectorAll('product-variant-selects').forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})(); */


(function () {
  'use strict';

  const MANNEQUIN_ACTIVE_CLASS = 'product-option__label--mannequin-active';
  let pendingGalleryUrl = null;

  function findGalleryImage() {
    return document.querySelector('.swiper--product-gallery .swiper-slide-active .media img');
  }

  function swapGalleryImageDirect(src) {
    if (!src) return;
    const img = findGalleryImage();
    if (!img) return;

    img.style.transition = 'none';
    img.style.opacity = '0';
    void img.offsetHeight;
    img.srcset = '';
    img.sizes = '';
    img.src = src;
    img.style.transition = 'opacity 0.18s ease';
    img.style.opacity = '1';
  }

  // ─── Preload every swatch image ───────────────────────────
  function preloadSwatchImages() {
    const inputs = document.querySelectorAll('.product-option__input[data-gallery-img]');
    inputs.forEach((input) => {
      const url = input.dataset.galleryImg;
      if (!url) return;
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    });
  }

  // ─── Delegación en document ───────────────────────────────────────────────
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (
      input.tagName !== 'INPUT' ||
      input.type !== 'radio' ||
      !input.classList.contains('product-option__input')
    ) return;

    const galleryUrl = input.dataset.galleryImg;
    if (!galleryUrl) return;

    pendingGalleryUrl = galleryUrl;
    swapGalleryImageDirect(galleryUrl);

    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) label.classList.remove(MANNEQUIN_ACTIVE_CLASS);
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-mannequin-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const label = trigger.closest('label');
    if (!label) return;

    const input = document.getElementById(label.getAttribute('for'));
    if (!input) return;

    const mannequinUrl = input.dataset.mannequinImg;
    const galleryUrl   = input.dataset.galleryImg;
    if (!mannequinUrl) return;

    const isActive = label.classList.contains(MANNEQUIN_ACTIVE_CLASS);
    if (isActive) {
      label.classList.remove(MANNEQUIN_ACTIVE_CLASS);
      if (galleryUrl) {
        pendingGalleryUrl = galleryUrl;
        swapGalleryImageDirect(galleryUrl);
      }
    } else {
      label.classList.add(MANNEQUIN_ACTIVE_CLASS);
      pendingGalleryUrl = mannequinUrl;
      swapGalleryImageDirect(mannequinUrl);
    }
  });

  // ─── Pub/sub: re-apply after the theme re-renders ───────────────────
  function hookPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      if (!pendingGalleryUrl) return;
      const url = pendingGalleryUrl;
      requestAnimationFrame(() => {
        const img = findGalleryImage();
        if (!img) return;
        img.srcset = '';
        img.sizes = '';
        img.src = url;
      });
    });

    return true;
  }

  function boot() {
    // Preload inmediato al cargar la página
    preloadSwatchImages();

    const hooked = hookPubSub();
    if (!hooked) {
      setTimeout(() => hookPubSub(), 500);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();